var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view',{key:_vm.$route.fullPath}),_c('notification'),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.loader.value),expression:"$root.loader.value"}],staticClass:"loader",attrs:{"src":"loader.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }